// extracted by mini-css-extract-plugin
export var text = "PageWysiwyg-module--text--Xc8VL";
export var twoColumns = "PageWysiwyg-module--twoColumns--3Eyho";